import React from "react";
import "./StudioForm.css";

function StudioForm({
  formData,
  setFormData,
  errors,
  setErrors,
  studiosOption,
  
}) {

  const handleInputChange = (field, value) => {    
    // Update formData
    setFormData({ ...formData, [field]: value });

    if(field === "studio_id"){
      setFormData((prevFormData) => ({
        ...prevFormData,
        local_selected_date: "",
      }));
    }

    // Remove the specific error for the field if it exists
    if (errors[field]) {
      setErrors((prevErrors) => {
        const { [field]: _, ...rest } = prevErrors; // Exclude the specific error
        return rest; // Return the rest of the errors
      });
    }
  };

  return (
    <div className="form-section">
      <div className={`form-group ${errors.studio_id ? "error" : ""}`}>
        <label>Studio</label>
        <select
          value={formData.studio_id}
          onChange={(event) =>
            handleInputChange("studio_id", event.target.value)
          }
        >
          <option value="" hidden>Select your Studio</option>
          {Array.isArray(studiosOption) && studiosOption.length > 0 ? (
            studiosOption.map((event) => (
              <option key={event.id} value={event.id}>
                {event.name}
              </option>
            ))
          ) : (
            <option value="" disabled>No available options</option>
          )}
        </select>
        {errors.studio_id && (
          <p className="error-message">{errors.studio_id}</p>
        )}
      </div>
    </div>
  );
}

export default StudioForm;
